module.exports = __webpack_public_path__ + "img/637-0e4db2.png";